import React from 'react';
import { FoodPhoto } from '../FoodPhoto';
export function FoodPhoto2() {
  return <FoodPhoto src="https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=1200&q=85" alt="Grilled salmon fillet with fresh herbs and lemon" caption="Pan-seared salmon with herbs, lemon, and seasonal greens" data-id="element-661" data-mp="3dh3t8mrbixrd" />;
}